<script lang="ts" setup>
import type { Item, AddonGroup, OrderItem } from '~/models';

import SaleItemAddons from './SaleItemAddons.vue';

const props = defineProps<{
  item: Item | OrderItem;
  editable?: boolean;
  isLoading?: boolean
}>();

const emits = defineEmits<{
  (e: 'remove'): void;
}>();

const totalText = computed<string>(() => {
  let total = 0;

  if ('total' in props.item) {
    total = props.item.total;
  } else {
    total = useItem(props.item as Item).getTotal();
  }

  return useCurrency().format(total);
});

const drsText = computed<string>(() =>
  props.item.drs ? useCurrency().format(props.item.drs * props.item.quantity) : ''
);

const addongroups = computed<AddonGroup[]>(() => {
  if ('addons' in props.item) {
    return props.item.addons;
  }

  return (props.item as Item).addongroups;
});

const onRemove = () => {
  emits('remove');
};
</script>

<template>
  <div
    class="px-2 text-sm flex flex-col"
    :class="{ 'pl-0': props.editable }"
  >
    <div class="flex gap-2 items-center justify-between">
      <span class="font-semibold flex items-center gap-2">
        <UButton
          v-if="props.editable"
          class="text-2xl text-company-1 cursor-pointer min-w-6"
          icon="ic:round-remove-circle-outline"
          variant="ghost"
          :disabled="props.isLoading"
          data-test="remove"
          @click="onRemove()"
        />

        <span data-test="description">
          {{ `${item.quantity}x ${item.name}` }}
        </span>
      </span>

      <span
        class="font-semibold text-end text-nowrap"
        data-test="total"
      >
        {{ totalText }}
      </span>
    </div>

    <SaleItemAddons
      v-for="group of addongroups"
      :key="group.uuid"
      :group="group"
      :editable="props.editable"
    />
    <div
      v-if="drsText"
      class="flex pl-2 gap-2 items-center justify-between"
      :class="{ 'pl-8': props.editable }"
    >
      <span class="font-semibold">
        DRS Deposit
      </span>
      <span
        class="font-semibold text-end"
        data-test="total"
      >
        {{ drsText }}
      </span>
    </div>
  </div>
</template>
